const stripTrailingSlash = (value: string) => value.replace(/\/+$/, '')

const viteEnv =
  typeof import.meta !== 'undefined' && typeof import.meta.env !== 'undefined'
    ? import.meta.env
    : ({} as Record<string, string | undefined>)

function resolveLocalMainSiteUrl() {
  if (typeof window === 'undefined') {
    return ''
  }

  const { hostname, protocol } = window.location

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:4010`
  }

  return window.location.origin
}

const mainSiteUrl = stripTrailingSlash(viteEnv.VITE_MAIN_SITE_URL ?? resolveLocalMainSiteUrl())
const authApiBaseUrl = stripTrailingSlash(
  viteEnv.VITE_AUTH_API_BASE_URL ?? resolveLocalMainSiteUrl(),
)
const fastcutApiBaseUrl = stripTrailingSlash(viteEnv.VITE_FASTCUT_API_BASE_URL ?? '')

function resolveBaseUrl() {
  if (authApiBaseUrl) return authApiBaseUrl
  if (mainSiteUrl) return mainSiteUrl
  return ''
}

const apiBaseUrl = resolveBaseUrl()

function resolveEndpoint(explicitValue: string | undefined, fallbackPath: string): string {
  if (explicitValue && explicitValue.trim()) {
    return explicitValue.trim()
  }

  if (apiBaseUrl) {
    return `${apiBaseUrl}${fallbackPath}`
  }

  return fallbackPath
}

export const authConfig = {
  mainSiteUrl,
  apiBaseUrl,
  fastcutApiBaseUrl,
  loginEndpoint: viteEnv.VITE_SUBSITE_LOGIN_ENDPOINT?.trim()
    ? viteEnv.VITE_SUBSITE_LOGIN_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/auth/login`
      : resolveEndpoint(undefined, '/api/auth/login'),
  registerEndpoint: viteEnv.VITE_SUBSITE_REGISTER_ENDPOINT?.trim()
    ? viteEnv.VITE_SUBSITE_REGISTER_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/auth/register`
      : resolveEndpoint(undefined, '/api/auth/register'),
  emailVerificationSendEndpoint: fastcutApiBaseUrl
    ? `${fastcutApiBaseUrl}/api/auth/email-verification/send`
    : resolveEndpoint(undefined, '/api/auth/email-verification/send'),
  emailVerificationVerifyEndpoint: fastcutApiBaseUrl
    ? `${fastcutApiBaseUrl}/api/auth/email-verification/verify`
    : resolveEndpoint(undefined, '/api/auth/email-verification/verify'),
  meEndpoint: viteEnv.VITE_SUBSITE_ME_ENDPOINT?.trim()
    ? viteEnv.VITE_SUBSITE_ME_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/auth/me`
      : resolveEndpoint(undefined, '/api/auth/me'),
  logoutEndpoint: viteEnv.VITE_SUBSITE_LOGOUT_ENDPOINT?.trim()
    ? viteEnv.VITE_SUBSITE_LOGOUT_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/auth/logout`
      : resolveEndpoint(undefined, '/api/auth/logout'),
  deleteAccountEndpoint: fastcutApiBaseUrl
    ? `${fastcutApiBaseUrl}/api/auth/account`
    : resolveEndpoint(undefined, '/api/auth/account'),
  launchExchangeEndpoint: resolveEndpoint(
    viteEnv.VITE_SUBSITE_LAUNCH_EXCHANGE_ENDPOINT,
    '/api/subsite/auth/exchange-ticket',
  ),
  accessSummaryEndpoint: viteEnv.VITE_FASTCUT_ACCESS_SUMMARY_ENDPOINT?.trim()
    ? viteEnv.VITE_FASTCUT_ACCESS_SUMMARY_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/subsite/fastcut/access-summary`
      : resolveEndpoint(undefined, '/api/subsite/fastcut/access-summary'),
  billingOptionsEndpoint: viteEnv.VITE_FASTCUT_BILLING_OPTIONS_ENDPOINT?.trim()
    ? viteEnv.VITE_FASTCUT_BILLING_OPTIONS_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/subsite/billing/options`
      : resolveEndpoint(undefined, '/api/subsite/billing/options'),
  paymentCreateOrderEndpoint: resolveEndpoint(undefined, '/api/payment/create-order'),
  paymentStatusBaseEndpoint: resolveEndpoint(undefined, '/api/payment/status'),
  toolAccessReserveEndpoint: viteEnv.VITE_FASTCUT_TOOL_ACCESS_RESERVE_ENDPOINT?.trim()
    ? viteEnv.VITE_FASTCUT_TOOL_ACCESS_RESERVE_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/subsite/fastcut/tool-access/reserve`
      : resolveEndpoint(undefined, '/api/subsite/fastcut/tool-access/reserve'),
  toolAccessCommitEndpoint: viteEnv.VITE_FASTCUT_TOOL_ACCESS_COMMIT_ENDPOINT?.trim()
    ? viteEnv.VITE_FASTCUT_TOOL_ACCESS_COMMIT_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/subsite/fastcut/tool-access/commit`
      : resolveEndpoint(undefined, '/api/subsite/fastcut/tool-access/commit'),
  toolAccessReleaseEndpoint: viteEnv.VITE_FASTCUT_TOOL_ACCESS_RELEASE_ENDPOINT?.trim()
    ? viteEnv.VITE_FASTCUT_TOOL_ACCESS_RELEASE_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/subsite/fastcut/tool-access/release`
      : resolveEndpoint(undefined, '/api/subsite/fastcut/tool-access/release'),
  fastcutApiKeysEndpoint: viteEnv.VITE_FASTCUT_API_KEYS_ENDPOINT?.trim()
    ? viteEnv.VITE_FASTCUT_API_KEYS_ENDPOINT.trim()
    : fastcutApiBaseUrl
      ? `${fastcutApiBaseUrl}/api/subsite/fastcut/api-keys`
      : resolveEndpoint(undefined, '/api/subsite/fastcut/api-keys'),
}
